var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRctDown(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 322,
    height: 235,
    viewBox: "0 0 322 235",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M160.55 234.658C153.707 234.658 147.275 231.993 142.437 227.155L7.50233 92.2204C2.66397 87.3821 0 80.9508 0 74.1072C0 67.2653 2.66455 60.8318 7.50233 55.994L63.3789 0.138672L66.2776 3.03731L10.4009 58.8927C6.33743 62.9562 4.09975 68.3605 4.09975 74.1078C4.09975 79.8567 6.33743 85.2594 10.4009 89.3229L145.336 224.258C149.401 228.321 154.803 230.559 160.551 230.559C166.299 230.559 171.701 228.321 175.766 224.258L310.681 89.3229C314.746 85.2594 316.983 79.8567 316.983 74.1078C316.983 68.3611 314.746 62.9562 310.681 58.8927L274.851 23.0632L277.75 20.1645L313.58 55.994C318.418 60.8324 321.084 67.2659 321.084 74.1072C321.084 80.9508 318.418 87.3826 313.58 92.2204L178.665 227.155C173.826 231.994 167.393 234.658 160.55 234.658Z",
    fill: "url(#paint0_linear_740_10582)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_740_10582",
    x1: 74.2886,
    y1: 132.733,
    x2: 318.777,
    y2: 132.653,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBB640"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRctDown);
export default __webpack_public_path__ + "static/media/rctDown.0339940a95a7efae941981810978486f.svg";
export { ForwardRef as ReactComponent };